import { createContext, useState, useMemo, useContext } from "react";

export const AuthDataContext = createContext(null);

const initialAuthData = {};

const AuthDataProvider = (props) => {
  const [authData, setAuthData] = useState(JSON.parse(localStorage.getItem("user")) || initialAuthData);

  const onLogout = () => setAuthData(initialAuthData);

  const onLogin = (newAuthData) => {
    setAuthData(newAuthData);
  };

  const authDataValue = useMemo(() => ({ ...authData, onLogin, onLogout }), [authData]);

  return <AuthDataContext.Provider value={authDataValue} {...props} />;
};

export const useAuthDataContext = () => useContext(AuthDataContext);

export default AuthDataProvider;
